import { type ITrackingProps } from '../constants';
import { trackingActions } from '../tracking-actions';

/**
 * Single dispatch seam for every betslip tracking payload built via ./build-betslip-events. Today
 * this is a thin pass-through to the shared GTM dataLayer singleton, matching current behavior
 * exactly — but centralising the call site here means a future change (e.g. routing through the
 * consent-aware trackEvent() from @cx-web/utils/dataLayer) only needs to happen once.
 */
export const trackBetslipEvent = (payload: ITrackingProps): void => {
  trackingActions.eventTracking(payload);
};
